module.exports = __webpack_public_path__ + "static/media/Pharos Logo Final_Square Blue.5e2f98e5.svg";